export function ReleaseDateTag({ releaseDate }: { releaseDate: string }) {
  return (
    <span className="text-xs text-gray-11 px-1 py-0.5 bshadow bshadow-gray-6">
      Available {formatReleaseDate(releaseDate)}
    </span>
  )
}

function formatReleaseDate(releaseDate: string): string {
  return new Date(releaseDate).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric"
  })
}
